import { render, staticRenderFns } from "./penetapan_massal.vue?vue&type=template&id=e1192b84&"
import script from "./penetapan_massal.vue?vue&type=script&lang=js&"
export * from "./penetapan_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports